import {Injectable} from '@angular/core';
import {AngularFireDatabase} from '@angular/fire/database';
import {AngularFireAuth} from '@angular/fire/auth';
import {v4 as uuid} from 'uuid';
import {AngularFirestore} from '@angular/fire/firestore';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {


  paymentId: string;

  constructor(private angularFireStore: AngularFirestore) {
    this.paymentId = uuid();
  }

  updateStats(amount, amountOfCards) {
    const appToken = environment.appToken;
    const data = {amount, appToken, amountOfCards};
    return this.angularFireStore.collection('statistics').doc(uuid()).set(data);
  }

  processPayment(intent: any, result: any, amount: number, amountOfCards: number) {
    const appToken = environment.appToken;
    amount = amount * 100;
    const payment = {intent, result, amount, appToken, amountOfCards};

    return this.angularFireStore.collection('payments').doc(this.paymentId).set(payment);
  }

}
